import {
  CheckBadgeIcon,
  ExclamationCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import toast from "react-hot-toast";

interface IToastCompProps {
  toastContent: any;
  icon: JSX.Element;
  message: string;
}

const ToastComp = ({ toastContent, icon, message }: IToastCompProps) => {
  return (
    <section
      id="toast"
      className="flex items-start justify-between gap-4 text-white"
    >
      <div className="flex items-start gap-2">
        <span className="block w-5">{icon}</span>
        <p className="text-sm font-semibold text-body">
          {message || "Something went Wrong"}
        </p>
      </div>
      <button
        onClick={() => toast.dismiss(toastContent.id)}
        type="button"
        className=" text-heading "
      >
        <XMarkIcon className="size-4" />
      </button>
    </section>
  );
};

function handleSuccessToast({ message }: { message: string }) {
  return toast((toast) => (
    <ToastComp
      toastContent={toast}
      message={message}
      icon={<CheckBadgeIcon className="size-5 text-success" />}
    />
  ));
}

function handleErrorToast({ message }: { message: string }) {
  return toast((toast) => (
    <ToastComp
      toastContent={toast}
      message={message}
      icon={<ExclamationCircleIcon className="size-5 text-error" />}
    />
  ));
}

function handleNetworkError({
  error,
}: {
  error: { response: any; message: string } extends Error ? any : any;
}) {
  const message = error?.response.data.message || "Internal Server Error!";
  handleErrorToast({ message });
}

// eslint-disable-next-line react-refresh/only-export-components
export { handleErrorToast, handleSuccessToast, handleNetworkError };
export default ToastComp;
